import React, { useCallback, useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate, useParams } from 'react-router-dom';
import { SuccessfullyModal } from '../../components/Modals/Modals'
import { getApi, postApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';


const EditTermsConditions = () => {
    const navigate = useNavigate()
    const { id } = useParams();
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [termsDetails, setTermsDetails] = useState('');
    const termsTitle = 'Terms Conditions'


    const fetchData = useCallback(async () => {
        await getApi(endPoints.gettermsbyid(id), {
            setResponse: (response) => {
                setTermsDetails(response?.data?.description || ''); // Initialize textarea value
            },
            setLoading,
            errorMsg: 'Failed to fetch data!',
        });
    }, [id]);


    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleSubmit = async () => {
        const payload = {
            title: termsTitle,
            description: termsDetails,
        };

        await postApi(endPoints.addterms, payload, {
            setLoading,
            successMsg: 'Terms & Conditions added successfully!',
            errorMsg: 'Failed to add terms & conditions!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/termsconditions'); // Redirect to the Privacy Policy list page
        }, 2000);
    };

    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Updated"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Edit Terms & Conditions</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
                            <p>View Terms & Conditions</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Terms & Conditions Details</h6>
                        </div>
                        <div className={addjob.editprivacypolicy}>
                            <label htmlFor="">Edit Terms & Conditions Details*</label>
                            <textarea
                                id="policyDetails"
                                placeholder="Edit the Terms & Conditions details here..."
                                value={termsDetails}
                                onChange={(e) => setTermsDetails(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button
                                onClick={handleSubmit}
                                style={{ background: '#F05423' }}
                                disabled={loading || !termsDetails.trim()}
                            >
                                {loading ? "Updating..." : "Update"}
                            </button>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default HOC(EditTermsConditions)